<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="fb_emname,fb_dpname"
      placeholder="输入申请人、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/fee_budget/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.fb_emname}}- {{item.fb_dpname}}</p>
          <p class="list-item-muted">{{item.fb_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.fb_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.fb_status!='已审核'}"
          >{{item.fb_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('fb_total')}}</em>
    </div>
    <!-- <add-button to="/oa/fee_budget_edit" /> -->
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
// import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    // AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/feebudget/list",
      filters: [
        {
          type: "date",
          name: "fb_year"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "fb_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "fb_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>